import { Row, Col } from '../../components/custom';

import firstImage from '../../images/solutions/customerExp/one.webp';
import secondImage from '../../images/solutions/customerExp/two.webp';
import thirdImage from '../../images/solutions/customerExp/three.webp';

export default function CustomerExp()
{
    return (
        <Col id='customer-experience'>
            <span className='mainTitle title'>Customer Experience Intelligence</span>
            <Row className='big'>
                <img src={firstImage} alt='firstImage'/>
                <Col className='content'>
                    <span className='title'>See What They See. Fix What They Feel</span>
                    <Col className='descsmall'>
                        <span>Every customer interaction — a purchase, a support call, a product complaint — is an opportunity to listen. But raw feedback alone isn't enough. To create loyalty and reduce churn, you need to decode what customers are actually telling you across their journey.</span>
                        <span>Our <strong> Customer Experience Intelligence Suite </strong> helps organizations listen intelligently, interpret feedback with clarity, and turn insight into experience-led growth. We guide you through survey strategy, analysis, and action — no platforms, no lock-ins — just high-impact consulting that makes your customers feel seen and heard.</span>
                    </Col>
                </Col>
            </Row>
            <Row className='big'>
                <Col className='content'>
                    <span className='title'>What We Help You Do</span>
                    <Col className='descsmall'>
                        <span>
                            <strong>Design Smarter Listening Programs</strong>
                            <br/>
                            Create targeted feedback touchpoints across the customer journey — from onboarding to renewals -with surveys that ask the right questions at the right time.
                        </span>
                        <span>
                            <strong>Uncover Deeper Insight</strong>
                            <br/>
                            Blend structured data with open text and social signals to reveal emotions, root causes, and unmet needs — not just what happened, but why.
                        </span>
                        <span>
                            <strong>Map Sentiment Across Journeys</strong>
                            <br/>
                            See how customer experience varies by product, region, or persona. Spot drop-offs, delights, and experience gaps before they escalate.
                        </span>
                        <span>
                            <strong>Turn Feedback into Action</strong>
                            <br/>
                            Move from insight to impact with clear priorities, action plans, and tracked progress — not just reports.
                        </span>
                    </Col>
                </Col>
                <img src={secondImage} alt='secondImage'/>
            </Row>
            <Row className='big'>
                <img src={thirdImage} alt='thirdImage'/>
                <Col className='content'>
                    <span className='title'>Our Unique Value</span>
                    <Col className='descsmall'>
                        <span>
                            <strong>Solution-Focused, Not Software-Bound</strong>
                            <br/>
                            We work with your existing survey platforms and CRMs — no need to buy or implement new tools.
                        </span>
                        <span>
                            <strong>Emotion + Insight, Not Just Metrics</strong>
                            <br/>
                            We interpret both what customers say and how they feel — through smart sentiment analysis and human interpretation.
                        </span>
                        <span>
                            <strong>Agile & Flexible</strong>
                            <br/>
                            Whether it's a one-time audit, quarterly program, or long-term partnership, we flex to meet your CX insight needs.
                        </span>
                        <span>
                            <strong>Business-Aligned CX</strong>
                            <br/>
                            We connect customer feedback to business outcomes like churn, upsell, support cost, and advocacy — making insights relevant to executives.
                        </span>
                    </Col>
                </Col>
            </Row>
            <Col className='small'>
                <span className='title'>Ready to Hear What Really Matters to Your Customers?</span>
                <Col className='content descsmall'>
                    <span>We help CX leaders, marketers, and customer-facing teams move beyond scattered feedback to uncover what truly shapes satisfaction, loyalty, and churn.</span>
                    <span>Let's turn your customer insights into clear direction, smarter decisions, and experiences that keep people coming back.</span>
                    <span><strong>Explore a tailored CX intelligence approach for your business.</strong></span>
                </Col>
            </Col>
        </Col>
    )
}